import {
    SET_DATE,
    CLEAR_DATE,
    SET_UPLOAD_PROGRESS,
    SET_UPLOAD_SUCCESS,
    SET_UPLOAD_FAILURE,
    SET_IMAGE_DATA,
    REMOVE_IMAGE,
    REMOVE_SEVERAL_UPLOADED_IMAGES,
    REMOVE_ALL
} from '../actionTypes';
import { IMAGE_UPLOAD_REQUEST } from "../constants"

export const setDate = (date) => ({
    type: SET_DATE,
    payload: date,
});

export const setUploadSuccess = (data) => ({
    type: SET_UPLOAD_SUCCESS,
    payload: data
})

export const setUploadFailure = (data) => ({
    type: SET_UPLOAD_FAILURE,
    payload: data
})

export const removeSeveralUploadedImages = (data) => ({
    type: REMOVE_SEVERAL_UPLOADED_IMAGES,
    payload: data
})

export const setUploadProgressData = (data) => ({
    type: SET_UPLOAD_PROGRESS,
    payload: data
})

export const clearDate = () => ({
    type: CLEAR_DATE,
});

export const removeAllImageUploads = () => ({
    type: REMOVE_ALL,
})

export const startImageUploading = (data) => ({
    type: IMAGE_UPLOAD_REQUEST,
    payload: data
})

export const setImageData = (images) => ({
    type: SET_IMAGE_DATA,
    payload: images
});

export const removeImageData = (fileName) => ({
    type: REMOVE_IMAGE,
    payload: fileName
})


// WEBPACK FOOTER //
// ./src/shared/redux/actions/index.js